import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Router } from '@/Router';
import { GamerMode, RippleStack } from '@/components/animations';
import { GamerToggle } from '@/components/GamerToggle';
import { RippleToggle } from '@/components/RippleToggle';
import { ThemeToggle } from '@/components/ThemeToggle';
import { ModeProvider } from '@/providers/ModeProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ModeProvider>
          <BrowserRouter>
            <RippleStack />
            <GamerMode />
            <div className="fixed top-4 right-4 z-40" data-gamer-immune>
              <ThemeToggle />
            </div>
            <div className="fixed right-4 bottom-4 z-40 flex items-center gap-2" data-gamer-immune>
              <GamerToggle />
              <RippleToggle />
            </div>
            <Router />
          </BrowserRouter>
        </ModeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
